import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, inject, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../../core/services/alert.service';
import { globalModules } from '../../utils/global-modules';
import { IconComponent } from '../icon/icon.component';

interface Alert {
  message: string;
  type: string;
  id: number;
  state: 'open' | 'closed';
}

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [...globalModules],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css',
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(120%)', opacity: 0, scale: 0.95 }),
        animate(
          '400ms ease-out',
          style({ transform: 'translateX(0)', opacity: 1, scale: 1 })
        )
      ]),
      transition(':leave', [
        animate(
          '300ms ease-in',
          style({ transform: 'translateX(100%)', opacity: 0, scale: 0.95 })
        )
      ])
    ])
  ]
  ,
})
export class AlertComponent implements OnInit {
  alerts: Alert[] = [];

  private subscription!: Subscription;
  private alertService = inject(AlertService);
  alertIcons: Record<string, IconComponent['icon']> = {
    success: 'CHECK_CIRCLE',
    info: 'INFO',
    error: 'ERROR',
    warning: 'WARNING',
  };

  alertTitleMapper: Record<string, string> = {
    success: 'SUCCESSFUL',
    info: 'INFORMATION',
    error: 'ERROR',
    warning: 'WARNING',
  };

  private alertCounter = 0;

  ngOnInit() {
    this.subscription = this.alertService.alert$.subscribe((alert) => {
      const newAlert: Alert = {
        message: alert.message,
        type: alert.type,
        id: this.alertCounter++,
        state: 'open',
      };

      this.alerts.push(newAlert);

      setTimeout(() => {
        this.closeAlert(newAlert.id);
      }, 7000);
      
    });
  }

  closeAlert = (id: number) => {
    this.alerts = this.alerts.filter((alert) => alert.id !== id);
  };

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  trackById(index: number, alert: Alert) {
    return alert.id;
  }
}
